import { render } from "./show_reports_components.vue?vue&type=template&id=edc2f990"
import script from "./show_reports_components.vue?vue&type=script&lang=js"
export * from "./show_reports_components.vue?vue&type=script&lang=js"

import "./show_reports_components.vue?vue&type=style&index=0&id=edc2f990&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__